export default function offerFavouritesOptionsResolver({ offer, itemSettings, offerSettings, on }) {
    return {
        bind: {
            offer,
            settings: itemSettings,
            favouritesSettings: offerSettings.favourites,
        },
        on: {
            'add-to-favourites-click': on.addToFavouritesClick,
            'remove-from-favourites-click': on.removeFromFavouritesClick,
        },
    };
}
